export default "__VITE_ASSET__DeSo8jBO__"